import {Component, inject, input, output} from '@angular/core';
import {ActionEvent} from './interfaces/action.interface';
import {TabsInterface} from '../../layout/interface/tabs.interface';
import {AuthService} from '../../../autorization/auth/auth.service';
import {Profile} from '../../../core/interface/profile/profile.interface';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'mobile-menu',
  imports: [],
  templateUrl: './mobile-menu.html',
  styleUrl: './mobile-menu.scss',
})
export class MobileMenu {
  public tabs = input<TabsInterface| undefined>();
  public profileInfo = input<Profile| undefined>();

  public onfMainLink = environment.portalOnfUrl;
  private authService = inject(AuthService)
  public action = output<ActionEvent>();
  public isAuth = this.authService.isAuthenticated()

  public closeModelMenu(){
    this.action.emit({type: 'close'});
  }

  public logout(){
    this.authService.logout()
  }
  public login(){
    this.authService.login()
  }
  protected readonly environment = environment;
}
